import React, { useState,useEffect } from "react";
import { Link,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import { ChangeDateStringOnlyDate, unescapeHtml } from "../../components/common/Common";

const QuestionView = () => {
  const { board_idx } = useParams();
  const ch_idx = Number(localStorage.getItem('childrenIndex'));

  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  //공지사항
  const [varQuestionInfo,setQuestionInfo] = useState({});

  const GetQuestionInformation = async () => {
    const sendData = {board_idx:board_idx,ch_idx:ch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_question_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1){
        const questionInfo = datas.results;
        if(questionInfo.length > 0) setQuestionInfo(questionInfo[0]);
      } 
    });
  }
  
  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    GetQuestionInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return(
    <div className="vh-content normal-wrap">
      <HeaderUserTitle varPageTitle={'1:1 문의 상세'} varBackString={'/Parents/Question'}/>
      <div className="vh-content-body">
        <div className="center-wrap">
          <div className="inq-wrap">
            <div className="inq-con">
              <div className="inq-quest-box">
								<ul>
									<li>
										<p>문의 일자</p><div>{ChangeDateStringOnlyDate(varQuestionInfo.board_rdate)}</div>
									</li>
									<li>
										<p>학부모(원아)</p><div>{varQuestionInfo.mem_name} ({varQuestionInfo.ch_name})</div>
									</li>
									<li>
										<p>문의 제목</p><div>{unescapeHtml(varQuestionInfo.board_title)}</div>
									</li>
									<li>
										<p>문의 내용</p><div>{unescapeHtml(varQuestionInfo.board_question)}</div>
									</li>
								</ul>
							</div>
							<div className="inq-answer-box">
								<ul>
									<li>
										<p>처리 여부</p>
										<div className={varQuestionInfo.board_status===1?"state":"state on"}>{varQuestionInfo.board_status===2?"답변완료":"답변대기"}</div>
									</li>
                  {varQuestionInfo.board_status!==2?null:
                    <li>
                      <p>답변</p>
                      <div>{unescapeHtml(varQuestionInfo.board_answer)}</div>
                    </li>
                  }
								</ul>
							</div>
            </div>
          </div>
        </div>
        <div className="form-contoller bt-btn st02">
					<Link to={'/Parents/Question'} className="form-contoller-btn btn-no" style={{width:"100%"}}>이전</Link>
				</div>
      </div>
    </div>
  );
}
export default QuestionView;